export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/local_seo.761c30a.svg";